import { c as _c } from "react/compiler-runtime";
import type { SVGProps } from 'react';
export const IconGallery = t0 => {
  const $ = _c(10);
  let height;
  let props;
  let size;
  let width;
  if ($[0] !== t0) {
    ({
      size,
      width,
      height,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = height;
    $[2] = props;
    $[3] = size;
    $[4] = width;
  } else {
    height = $[1];
    props = $[2];
    size = $[3];
    width = $[4];
  }
  const t1 = size ?? width ?? 24;
  const t2 = size ?? height ?? 24;
  let t3;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <path fill="currentColor" fillRule="evenodd" d="M6.84 3.038C4.3 3.36 2.52 5.104 2.079 7.702c-.093.546-.1 2.824-.084 24.668l.019 24.065.169.59c.57 1.995 1.99 3.278 4.24 3.832l.562.139h50.287l.61-.163c2.063-.552 3.39-1.924 3.963-4.1l.143-.544V7.564l-.169-.59c-.566-1.981-1.952-3.243-4.206-3.83l-.532-.14-24.92-.007c-13.707-.005-25.1.014-25.32.041m.168 3.914c-.409.122-.714.463-.88.985-.132.41-.132.419-.132 17.598v17.188h8.191l4.136-5.334c4.383-5.65 4.593-5.896 5.513-6.433a5.92 5.92 0 0 1 5.47-.24c.68.322.988.548 1.802 1.323l.67.638 3.473-4.48c1.91-2.464 3.626-4.64 3.813-4.835 1.012-1.06 2.6-1.717 4.15-1.715 1.43.002 2.918.585 3.96 1.552.498.462 7.4 9.375 7.546 9.745.152.383.108 1.138-.088 1.508-.413.784-1.356 1.202-2.267 1.005-.685-.148-.625-.081-4.404-4.945-1.939-2.496-3.606-4.594-3.704-4.661a1.8 1.8 0 0 0-1.024-.322c-.462 0-.784.099-1.072.328-.13.103-2.122 2.62-4.428 5.592-2.306 2.973-4.274 5.48-4.373 5.573-.549.51-1.494.648-2.213.324-.309-.14-.64-.424-1.88-1.614-1.642-1.575-1.813-1.695-2.434-1.697-.479-.002-.888.144-1.176.418-.132.125-1.616 2.003-3.299 4.172-1.683 2.17-3.088 3.979-3.122 4.021-.05.062 3.83.077 19.353.077h19.415V25.448c0-15.206-.012-17.313-.096-17.588-.13-.423-.466-.711-1.022-.877l-.425-.127-24.58.004c-21.086.004-24.62.017-24.873.092m9.735 5.172c-2.238.45-4.094 1.926-4.926 3.916-.357.855-.428 1.249-.43 2.402-.001.925.019 1.15.14 1.58a6.4 6.4 0 0 0 1.69 2.898c2.573 2.599 6.843 2.637 9.482.086s2.598-6.68-.09-9.168a6.7 6.7 0 0 0-2.963-1.625c-.647-.17-2.257-.219-2.903-.089m.885 3.799c-.853.12-1.436.495-1.92 1.237-.563.862-.453 2.158.25 2.946.833.934 2.151 1.181 3.29.619.362-.18.906-.706 1.091-1.055.996-1.884-.57-4.048-2.711-3.747M5.996 51.187c0 5.223-.01 5.088.443 5.484.16.14.403.265.675.346l.425.127h24.552c27.344 0 24.987.04 25.424-.428.145-.155.273-.39.358-.653.127-.4.13-.541.13-4.965v-4.554H32l-26.004.002z" clipRule="evenodd" />;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== props || $[7] !== t1 || $[8] !== t2) {
    t4 = <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 64 64" width={t1} height={t2} {...props}>{t3}</svg>;
    $[6] = props;
    $[7] = t1;
    $[8] = t2;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  return t4;
};
IconGallery.displayName = 'IconGallery';